import axios from './axios';

const API_VENDORS = '/api/v1/vendors';
const API_AMC = '/api/v1/amc-contracts';

/**
 * Vendors
 */
export const getVendors = async (params = {}) => {
  return await axios.get(API_VENDORS, { params });
};

export const getVendor = async (id) => {
  return await axios.get(`${API_VENDORS}/${id}`);
};

export const createVendor = async (data) => {
  return await axios.post(API_VENDORS, data);
};

export const updateVendor = async (id, data) => {
  return await axios.put(`${API_VENDORS}/${id}`, data);
};

export const deleteVendor = async (id) => {
  return await axios.delete(`${API_VENDORS}/${id}`);
};

export const getVendorStats = async () => {
  return await axios.get(`${API_VENDORS}/stats`);
};

/**
 * AMC Contracts
 */
export const getAmcContracts = async (params = {}) => {
  return await axios.get(API_AMC, { params });
};

export const getAmcContract = async (id) => {
  return await axios.get(`${API_AMC}/${id}`);
};

export const createAmcContract = async (data) => {
  return await axios.post(API_AMC, data);
};

export const updateAmcContract = async (id, data) => {
  return await axios.put(`${API_AMC}/${id}`, data);
};

export const deleteAmcContract = async (id) => {
  return await axios.delete(`${API_AMC}/${id}`);
};
